import store from '@/store'
import { lazyLoad } from '../../index'

export default {
  path: 'artistcollections',
  component: lazyLoad('Admin/Data/ArtistCollections'),
}
